import types from './actionTypes';

export const createPool = (id, payload) => ({
    type: types.CREATE_POOL,
    meta: {
        id,
    },
    payload,
});

export const deletePool = id => ({
    type: types.DELETE_POOL,
    meta: {
        id,
    },
});

export const sortPool = (id, info) => ({
    type: types.SORT_POOL,
    meta: {
        id,
        info,
    },
});
